<div class="export-modal">
    <div class="modal-header">
        <div class="export-modal-header">
            <h5>Select email recipients</h5>
            <p class="sub">Select the recipients of this file, you may select multiple cc values</p>
        </div>
        <button type="button" class="close" data-dismiss="modal" [pTooltip]="translate?.general.buttons.close.singular" tooltipPosition="left" (click)="modalRef.hide();">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <form [formGroup]="emailForm">
        <div class="modal-body pt-0">
            <!-- 4: SELECT EMAIL RECIPIENTS -->
            <section class="section">
                 <div class="grid-1">
                  <div class="position-relative">
                    <label class="field-label mandatory">To</label>
                    <input type="email" pInputText placeholder="Enter a recipient..."  formControlName="to"/>
                     <div class="p-error text-10" *ngIf=" emailForm.controls['to']?.touched && emailForm.controls['to'].invalid ">
                            <span *ngIf=" emailForm.controls['to']?.errors?.required " id="label_JobOwnerReqField" >{{translate?.general.validationFE.requiredField}}</span>
                            <span *ngIf="emailForm.controls['to'].errors?.pattern" class="text-10 p-error" id="label_ContaEmailInvalid"
                                >{{translate?.general.validationFE.invalidEmailFormat}}</span>
                        </div>
                  </div>
                </div>
                 <div class="grid-1">
                  <div>
                    <label class="field-label">CC
                          <i class="fa-regular fa-info-circle" [pTooltip]="translate?.setup.configuration.notifications.tooltips.separateEmail.singular"></i>
                    </label>  
                    <input  pInputText [ngClass]="{'ng-invalid ng-dirty': emailForm.controls['ccEmail']?.touched && emailForm.controls['ccEmail'].invalid}"
                        formControlName="ccEmail" [(ngModel)]="emailAddress" 
                        placeholder="Separate multiple email addresses with commas...">
                    <!-- <textarea pInputTextarea rows="3" formControlName="emails" placeholder="Separate multiple email addresses with commas..."></textarea> -->
                    <!-- <div class="p-error text-10" *ngIf="emailForm.get('ccEmail')?.value?.length <= 3 && emailForm.get('to')?.value?.length !=0">
                            <span  id="label_JobOwnerReqField" > Maximum 3 email addresses allowed</span>
                    </div> -->
                  </div>
                </div>
            </section>


        </div>

        <div class="modal-footer">
            <button type="button" class="custella-btn-white" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
            <p-button [label]="translate?.general.buttons.send.singular" styleClass="h-32"  [disabled]="emailForm.invalid" (onClick)="submit()"></p-button>
        </div>
    </form>
</div>